module.exports = __webpack_public_path__ + "img/logo.21f1fbd8.svg";